import React from 'react';
import { Outlet } from 'react-router-dom';
import { Footer } from './Footer';
import { Header } from './Header';

interface LayoutProps {
  children?: React.ReactNode;
}

/**
 * Public layout component for unauthenticated pages
 * 
 * Supports two modes:
 * - Nested routing: Uses <Outlet /> when no children provided (layout stays mounted)
 * - Direct children: Uses children prop when provided (legacy support)
 */
export const Layout: React.FC<LayoutProps> = ({ children }) => {
  // Use Outlet for nested routing (prevents layout remount on navigation)
  // Fall back to children for backwards compatibility
  const content = children ?? <Outlet />;
  
  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Header />
      <main className="pt-0">
        {content}
      </main>
      <Footer />
    </div>
  );
};
